<template>
    <v-container fluid>
        <s-toolbar label="Pendientes por Abastecer Detalle" color="#999999" :isColor="true" class="white--text"
            :print="Object.keys(selected).length > 0" @print="printPDF" />

        <v-col>
            <v-row justify="center" dense>
                <v-col cols="12" lg="3" md="3" sm="6">
                    <b>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                            hide-details></v-text-field>
                    </b>
                </v-col>

                <v-col cols="12" lg="3" md="3" sm="6">
                    <s-date label="Fecha Inicio" v-model="BeginDate"></s-date>
                </v-col>
                <v-col cols="12" lg="3" md="3" sm="6">
                    <s-date label="Fecha Fin" v-model="EndDate"></s-date>
                </v-col>

                <v-col cols="12" lg="3" md="3" sm="6">
                    <s-select-definition :def="1181" label="Destino" v-model="TypeDestiny"></s-select-definition>
                </v-col>
            </v-row>
        </v-col>
        <v-card dense style="margin-top: 20px">
            <v-col cols="12" class="pa-0">
                <v-data-table item-key="LppID" dense :headers="headers" :items="items" :search="search" disable-sort
                    :loading="loadingData" v-model="selected" single-select @click:row="rowSelected">
                    <template v-slot:item.RcfID="row">
                        <v-chip style="font-size: 10px;" small dark outlined :color="'blue'">
                            {{ row.item.RcfID }}
                        </v-chip>
                    </template>
                    <template v-slot:item.SupplyDate="row">
                        {{ $fun.formatDateView(row.item.SupplyDate) }}
                    </template>
                    <template v-slot:item.LlpDate="row">
                        {{ $fun.formatDateView(row.item.LlpDate) }}
                    </template>
                    <template v-slot:item.DateTreatment="row">
                        {{ $fun.formatDateView(row.item.DateTreatment) }}
                    </template>
                    <template v-slot:item.InProcess="row">
                        <v-chip small dark outlined :color="row.item.xCount == 0 ? 'error' : 'success'">
                            {{ row.item.InProcess }}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-col>

            <v-col cols="12" v-for="item in selected">
                <qr-code id="qrCodeImg" :text="item.LlpID +
                    ', Jabas: ' +
                    item.LlpQuantityJaba +
                    ',' +
                    item.TypeCaliberName +
                    ',' +
                    item.TypeCultiveName +
                    ',' +
                    item.VrtName +
                    ',' +
                    item.TypeDestinyName +
                    ',' +
                    item.TypeDestiny
                    " error-level="H" hidden>
                </qr-code>
                <br />
            </v-col>
        </v-card>
    </v-container>
</template>

<script>
import _sSupplying from "../../../services/FreshProduction/SupplyingService";
import _sLotProdCalibratedPrintQRService from "../../../services/FreshProduction/PrfLotProductionCalibratedQRService";
import qrCode from "vue-qr-generator";


export default {
    components: { qrCode },
    data() {
        return {
            headers: [
                { text: "ID Detalle", value: "LppID", width: 100 },
                { text: "Parihuela", value: "LlpID", width: 100 },
                { text: "Lote Producción", value: "RcfID", width: 120 },
                { text: "Fecha de Abastecimiento", value: "SupplyDate", width: 100, align: "center" },
                { text: "Fecha de Calibrado", value: "LlpDate", width: 100, align: "center" },
                { text: "Calibre", value: "TypeCaliberName", width: 100 },
                { text: "Cant. Jabas", value: "LppQuantityJaba", width: 100 },
                { text: "Linea Negocio", value: "TypeBsnLineName", width: 100, align: "center" },
                { text: "Tipo Cultivo", value: "TypeCropName", width: 100 },
                { text: "Cultivo", value: "TypeCultiveName", width: 100 },
                { text: "Variedad", value: "VrtName", width: 100 },
                { text: "Calidad", value: "IsReworkType", width: 100 },
                { text: "Estado", value: "InProcess", width: 200 },
                { text: "Fecha de Hidrotérmico", value: "DateTreatment", width: 100, align: "center" },
            ],
            items: [],
            BeginDate: null,
            EndDate: null,
            TypeDestiny: 0,
            search: "",
            loadingData: false,
            selected: [],
            itemsDetail: [],
            WbbNetWeight: 0,
        };
    },

    created() {
        //this.initialize()
    },

    watch: {
        'TypeDestiny'() {
            this.initialize()
        },
        'BeginDate'() {
            this.initialize()
        },
        'EndDate'() {
            this.initialize()
        }
    },

    methods: {
        initialize() {

            this.loadingData = true;
            const params = {
                BeginDate: this.BeginDate,
                EndDate: this.EndDate,
                TypeDestiny: this.TypeDestiny,
                Search: this.search
            }
            _sSupplying.getSupplyingEarringDetail(params, this.$fun.getUserID()).then(data => {
                if (data.status == 200) {
                    this.items = data.data;
                    this.items.forEach(element => {
                        element.SecCreate = this.$moment(element.SecCreate).format(this.$const.FormatDateTimeDB);
                    });

                    this.loadingData = false;
                }
            });
        },
        formatRcfDates(value) {
            if (!value) return '';

            return value
                .split(',')                // 1️⃣ string → array
                .map(v => v.trim())        // 2️⃣ limpiar espacios
                .filter(v => v)            // 3️⃣ eliminar vacíos
                .map(v => this.$fun.formatDateView(v)) // 4️⃣ formatear fecha
                .join(', ');               // 5️⃣ volver a string
        },
        rowSelected(val) {
            this.selected = val !== undefined || val !== null ? [val] : [];
        },
        printPDF() {
            if (this.selected.length > 0) {
                // console.log("selected", this.selected);
                _sLotProdCalibratedPrintQRService.GetDetailQR(this.selected[0].LlpID, this.$fun.getUserID()).then(resp => {
                    if (resp.status == 200) {
                        this.itemsDetail = resp.data;
                        this.WbbNetWeight = 0;
                        this.itemsDetail.forEach(element => {
                            this.WbbNetWeight += element.WbbNetWeight
                        });
                        this.modalPrintPDF();
                    }
                });
            }
        },
        modalPrintPDF() {
            var imgAll = document.querySelector("#qrCodeImg img");
            // console.log("Image", imgAll);

            // var daten = new Date().toLocaleString();
            var daten = this.$fun.formatDateTimeView(new Date());

            // let ScfCode = "";
            // if (this.selected[0].ScfCode != "") {
            // 	ScfCode = "<h2 style='margin: 0px'><b>Tarima: " + this.selected[0].ScfCode + "</b></h2>";
            // }

            // let ScfCode = "";
            // if (this.selected[0].ScfCode != "") {
            // 	ScfCode = "<h2><b>Tarima: " + this.selected[0].ScfCode + " || REPROCESO</b></h2>";
            // } else {

            // 	ScfCode = "<h2><b>REPROCESO</b></h2>";
            // }

            let ScfCode = "";
            if (this.selected[0].ScfCode != "") {
                ScfCode = " || Tarima: " + this.selected[0].ScfCode;
            }

            let Process = this.selected[0].Process == 1 ? 'REPROCESO' : '';

            var Pagelink = "about:blank";
            var pwa = window.open(Pagelink, "_new");
            pwa.document.open();
            pwa.document.write(
                "<html><head><scri" +
                "pt>function step1(){\n" +
                "setTimeout('step2()', 10);}\n" +
                "function step2(){window.print();window.close()}\n" +
                "</scri" +
                "pt><style>body { font-family: 'Segoe UI', 'Roboto', 'Arial', sans-serif; } table { border-collapse: collapse; }</style><style media='print'>  @media print  { @page { margin-left: 4cm; {} </style></head><body onload='step1()'> \n" +
                "<div class='col col-12 justify-center'>",
            );


            /* imgAll.forEach(element => { */

            // pwa.document.write(
            // 	"<div class='col col-4' style='margin: 20px 20px 20px 20px;'><img alt='Scan me!' style='display: block;'  src='" +
            // 		imgAll.currentSrc +
            // 		"' /></div>",
            // );

            pwa.document.write(
                "<table  border='1'> " +
                "<tr><td colspan='3' style='text-align:center;padding:4px'> <img  width='100px'src='https://www.sunshineperu.com/img/logo.svg'alt='User Image'ref='userImage'/> </td></tr>" +
                "<tr><td rowspan='7' style='padding: 10px ;'><img alt='Scan me!' style='display: block;'  src='" +
                imgAll.currentSrc +
                "' /> </td>" +
                "<td style='text-align:center;padding: 2px ;'>Fecha de trat.</td><td style='width:90px;'></td></tr> ",
                "<tr><td style='text-align:center;padding: 2px ;'>Canasta</td><td></td></tr>",
                "<tr><td style='text-align:center;padding: 2px ;'>Tanque</td><td></td></tr>",
                "<tr><td style='text-align:center;padding: 2px ;'>Tratamiento</td><td></td></tr>",
                // "<tr><td style='text-align:center;padding: 2px ;'>Fecha de trat.</td><td></td></tr>",
                "<tr><td style='text-align:center;padding: 2px ;'>H. Inicio</td><td></td></tr>",
                "<tr><td style='text-align:center;padding: 2px ;'>H. Final</td><td></td></tr>",
                " ",
                "</table>",
            );

            pwa.document.write("<div ><table border='0'>");
            pwa.document.write(
                "<tr><td colspan='4'>Datos Generales: " +
                "<tr>" +
                "<td>" + "<b>" + this.selected[0].LlpID + "</b>" +
                "</td><td> || " + "<b>" + this.selected[0].TypeCultiveName + "</b>" +
                "</td><td> || " + "<b>" + this.selected[0].VrtName + "</b>" +
                "</td><td> || " + "<b>" + this.selected[0].TypeCropName + "</b>" +
                "</td><td> || " + "<b>" + this.selected[0].TypeDestinyName + "</b>" +
                "</td></tr>" +
                /* "</td><td> || " + "<b>" + this.WbbNetWeight.toFixed(2)+"</b>"+ */
                "<tr><td colspan='5'><h3 style='margin:0;font-size:1rem'><b>" + this.selected[0].TypeCaliberName
                + " || " + this.selected[0].TypeBsnLineName
                + " || N° Faja: " + this.selected[0].NumberGirdle
                + " || " + this.selected[0].TypeDestinyPreciseName
                + ScfCode
                + "</b></h3></td></tr>" +
                " </table></div>"
                // + ScfCode  +  "<span class='h1' style='font-size: large;'><b>" + this.selected[0].TypeBsnLineName + "</b></span><br>" 
                //  + " <span><b> N° Faja: " + this.selected[0].NumberGirdle +  "</b</span>"
            );
            pwa.document.write("");

            this.itemsDetail.forEach(detail => {

                pwa.document.write("<div ><table border='0'>");

                pwa.document.write(
                    "<tr ><td colspan='3'>Lote Produccion: <div style='font-size:25px;display:inline;'><b>" + detail.RcfID + "-" + detail.RcfCode + "</b></div>, Jaba: " + detail.LppQuantityJaba + ", Kg: " + detail.WbbNetWeight.toFixed(2) + "</td></tr>"
                    /* "<tr><td>Lote Produccion: </td><td>" + detail.RcfID +"</td></tr>" +
                    "<tr><td>Jabas: </td><td>" + detail.LppQuantityJaba +"</td></tr>" */
                );

                pwa.document.write(
                    // "<tr><td>Productor: </td><td>" + detail.PrdCardName +"</td></tr>" +
                    // "<tr><td>Fundo: </td><td>" + detail.FagName + " || "+ detail.FltName + " || "+ detail.FltCodSenasa + "</td></tr>" + 
                    "<tr><td>Procedencia: </td><td>" + detail.ZonName + " - " + detail.TypeZonLocationName + "</td></tr>"
                );
                pwa.document.write(
                    "<tr><td>Codigo Senasa: </td><td>" + detail.CodSenasa + "</td></tr>"
                );

                pwa.document.write(
                    "<tr><td>Certificaciones: </td><td>" + detail.TcDescription + "</td></tr>",
                );
                pwa.document.write(
                    "<tr><td>Posición: </td><td>" + detail.LppPosition + "</td></tr>",
                );

                pwa.document.write(
                    "<tr><td>Fecha Creación: </td><td>" + this.$fun.formatDateTimeView(detail.PrintCreate) + "</td></tr>",
                );

                pwa.document.write(
                    "<tr><td>Creado por: </td><td>" + detail.NtpName + "</td></tr>",
                );

                pwa.document.write(
                    "<tr><td>Fecha Impresión: </td><td>" + daten + "</td></tr>",
                );

                pwa.document.write("</table>-------------------------------------------------------------</div>");

                pwa.document.write("</table></div>");
            });

            /* }); */

            pwa.document.write("<div style='font-size:60px; margin-top: 20px;'><b>" + Process + "</b></div>");
            pwa.document.write("</div></body></html>");
            pwa.document.close();
        }

    },
};
</script>
